module.exports = __webpack_public_path__ + "assets/img/1ebfd237db70dc05e8be552e305ea229.png";